module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cekp8"))).then(() => parcelRequire('hEqeo'));